module.exports = __webpack_public_path__ + "img/de.b46e2689.svg";